<template>
  <v-dialog v-model="$store.state.global_push_dialog" max-width="290"
    @click:outside="closeDialogSendmail(link, querydata)">
    <v-card>
      <v-card-title :class="text_color">
        <v-spacer />
        <div class="text-center">
          <div>{{ title }}</div>
        </div>
        <v-spacer />
      </v-card-title>

      <v-card-text>
        <v-spacer />
        <div class="text-center">
          <div>{{ message }}</div>
        </div>
        <v-spacer />
      </v-card-text>
      <!-- <v-card-text>
          <v-spacer />
          <div class="text-center">
            <div>Click anywhere to close.</div>
          </div>
          <v-spacer />
        </v-card-text> -->

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
                >Cancel</v-btn
              > -->
        <v-btn color="blue darken-1" text @click="closeDialogSendmail(link, querydata)">OK</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SuccessDialogPushpaymentIM",
  props: ["status", "title", "message", "text_color", "link", "querydata"],
  beforeDestroy() {
    // console.log("SuccessDialog beforeDestroy");
    // //this.$store.commit("set_global_dialog", false);
    // this.$store.state.global_dialog = false;
  },
  methods: {
    closeDialogSendmail(tlink, querydata) {
      //this.$store.commit("set_global_dialog", false);
      this.$store.state.global_push_dialog = false;
      if (tlink === "/reloadpage") {
        this.$router.go();
      } else {
        this.$router.push({ path: `${tlink}`, query: querydata });
      }
      // this.$router.push(`${tlink}`);
      //"/advance-list"
    },
  },
};
</script>

<style></style>